import React, { FC, useEffect, useState } from 'react';
import axios from 'axios';

import { UserPage } from "components/UserPage"
import { Section } from "components/Section"


type Stamp = {
    id: number;
    spotId: number;
    name: string;
    genre: string;
    created: string;
};


type Props = {};


export const StampCardEditPage: FC<Props> = (props) => {
    // @ts-ignore
    const id = props.match.params.id;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [stamps, setStamps] = useState<Stamp[][]>([]);
    const [page, setPage] = useState(0);
    const [name, setName] = useState('');
    const [load, setLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stamp, setStamp] = useState<Stamp | null>(null);
    const stampIcons = {
        '飲食店': '/img/map_stamp_icons/stamp-rest.png',
        'ヘアサロン': '/img/map_stamp_icons/stamp-cut.png',
        'スナックキャンディ': '/img/map_stamp_icons/stamp-candy.png',
        '宿泊': '/img/map_stamp_icons/stamp-hotel.png',
        'その他': '/img/map_stamp_icons/stamp-other.png',
        '自販機': '/img/map_stamp_icons/stamp-vend.png',
        '居酒屋・バー': '/img/map_stamp_icons/stamp-bar.png',
        'レストラン・カフェ': '/img/map_stamp_icons/stamp-cafe.png',
        'スイーツ': '/img/map_stamp_icons/stamp-sweets.png',
        '健康': '/img/map_stamp_icons/stamp-health.png',
        '医療・福祉': '/img/map_stamp_icons/stamp-medical.png',
        '小売': '/img/map_stamp_icons/stamp-retail.png',
        'エンタメ・レジャー': '/img/map_stamp_icons/stamp-entertainment.png',
        '習いごと': '/img/map_stamp_icons/stamp-education.png',
        'ビューティ': '/img/map_stamp_icons/stamp-beauty.png',
        'レンタルスペース': '/img/map_stamp_icons/stamp-rentalspace.png',
        'ビジネス': '/img/map_stamp_icons/stamp-buisiness.png',
        '保育園・幼稚園': '/img/map_stamp_icons/stamp-nursery.png',
        '農業': '/img/map_stamp_icons/stamp-agri.png',
    };

    const formatDate = (date: string) => {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = ('0' + (d.getMonth() + 1)).slice(-2);
        const dd = ('0' + d.getDate()).slice(-2);
        return `${yyyy}.${mm}.${dd}`;
    };

    useEffect(() => {
        async function initialize() {
            const { data: { stamps } } = await axios.get(
                `${window.location.origin}/api/map/stamps/${id ?? ''}`,
            );
            if (!stamps || stamps.length === 0) {
                window.location.href = '/map/stampcard';
                return;
            };
            if (id) {
                setName(stamps[0][0].name);
            };
            setStamps(stamps);
            setLoad(true);
        };
        initialize();
    }, []);

    async function deleteStamp() {
        if (loading) return;
        if (!stamp) {
            window.alert('スタンプの取り消しに失敗しました。');
            return;
        };
        try {
            const { data: { success, redirect } } = await axios.post(
                `${window.location.origin}/api/map/stamps/delete`,
                {
                    stampId: stamp.id,
                },
            );
            if (success) {
                window.location.reload();
            } else if (redirect) {
                window.location.href = redirect;
            } else {
                window.alert('スタンプの取り消しに失敗しました。');
            };
        } catch (e) {
            window.alert('スタンプの取り消しに失敗しました。');
        } finally {
            setIsModalOpen(false);
            setStamp(null);
            setLoading(false);
        };
    };

    if (!load) {
        return <UserPage title="Salon.jp | スタンプカード"></UserPage>
    };

    return (
        <UserPage>
            <Section fillOnSp>
                <div className="wrapper">
                    {(isModalOpen && stamp) && (
                        <div className="modal-mask" onClick={() => {
                            setStamp(null);
                            setIsModalOpen(false);
                        }}>
                            <div className="modal" onClick={(e) => e.stopPropagation()}>
                                <p>{name ? formatDate(stamp.created) : stamp.name}のスタンプを削除してもよろしいですか？</p>
                                <div className="actions">
                                    <button className="cancel-button" onClick={() => {
                                        setStamp(null);
                                        setIsModalOpen(false);
                                    }}>キャンセル</button>
                                    <button className="delete-button" onClick={deleteStamp}>削除</button>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="title">
                        <h1>スタンプ管理画面</h1>
                        <p>{name}</p>
                    </div>
                    <table className="stamps">
                        <thead>
                            <tr>
                                {!name && <th></th>}
                                <th>取得日</th>
                                {!name && <th>店舗名</th>}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {stamps[page].map((stamp) => (
                                <tr className="stamp">
                                    {!name && (
                                        <td>
                                            {/* @ts-ignore */}
                                            <img className="icon" src={stampIcons[stamp.genre]} />
                                        </td>
                                    )}
                                    <td>{formatDate(stamp.created)}</td>
                                    {!name && (
                                        <td>
                                            <span className="stamp-name">{stamp.name}</span>
                                        </td>
                                    )}
                                    <td className="delete-button-cell">
                                        <button
                                            className="delete-button"
                                            onClick={() => {
                                                setStamp(stamp);
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            <img src="/img/bin.png" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {stamps.length > 1 && (
                        <div className="pager">
                            <button
                                className="previous"
                                disabled={page === 0}
                                onClick={() => setPage(prev => prev - 1)}
                            >
                                {`<< 前のページへ`}
                            </button>
                            {new Array(stamps.length).fill(null).map((_, index) => (
                                <button className={["page", index === page ? 'active' : ''].join(' ')} onClick={() => setPage(index)}>{index + 1}</button>
                            ))}
                            <button
                                className="next"
                                disabled={(stamps.length - 1) === page}
                                onClick={() => setPage(prev => prev + 1)}
                            >
                                {`次のページへ >>`}
                            </button>
                        </div>
                    )}
                </div>
            </Section>

            <style jsx>{`
                .modal-mask {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.5);
                    z-index: 10;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .modal-mask > .modal {
                    border-radius: 20px;
                    min-width: 300px;
                    max-width: 50%;
                    height: 200px;
                    background: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    padding: 40px 20px;
                }
                .modal > p {
                    margin-bottom: 4px;
                    width: 70%;
                }
                .modal > .actions {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0 20px 0 20px;
                    width: 100%;
                    margin-top: 10px;
                }
                .actions > .cancel-button {
                    background: #c1c1c1;
                    border: none;
                    color: #fff;
                    padding: 3px 15px 3px 15px;
                    width: 140px;
                    border-radius: 40px;
                    margin-right: 20px;
                }
                .actions > .delete-button {
                    border: none;
                    background: #ff6e00;
                    padding: 3px 15px 3px 15px;
                    color: #fff;
                    border-radius: 4px;
                    width: 140px;
                    border-radius: 40px;
                    margin-left: 20px;
                }
                .wrapper {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                .title {
                    text-align: center;
                }
                .title > p {
                    margin-top: none;
                    margin-bottom: 60px;
                }
                .stamps{
                    margin: 0 auto;
                    border-collapse: collapse;
                    margin-bottom: 60px;
                    width: 70%;
                }
                .stamp {
                    border-top: 1px solid #707070;
                }
                .stamp:last-of-type {
                    border-bottom: 1px solid #707070;
                }
                .icon {
                    width: 36px;
                    height: 36px;
                }
                th {
                    font-size: 14px;
                }
                .td {
                    font-size: 18px;
                    padding: 0 10px;
                }
                th,
                td {
                    padding: 10px;
                    text-align: left;
                    font-weight: normal;
                }
                .delete-button-cell {
                    width: 30px;
                }
                .delete-button {
                    padding: 0;
                    background: none;
                    border: none;
                    width: 30px;
                    height: 30px;
                }
                .delete-button > img {
                    width: 30px;
                    height: 30px;
                }
                .pager {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 40px;
                }
                .next,
                .previous,
                .page {
                    border: 1px solid #b9b9b99a;
                    background: #fff;
                    height: 30px;
                }
                .previous {
                    color: ${page === 0 ? '#443f3d' : '#ff6e00'};
                }
                .next {
                    color: ${(stamps.length - 1) === page ? '#443f3d' : '#ff6e00'};
                }
                .page {
                    width: 30px;
                    color: #ff6e00;
                    background-color: #fff;
                }
                .page.active {
                    color: #fff;
                    background-color: #ff6e00;
                }
                @media screen and (max-width: 540px) {
                    .modal-mask > .modal {
                        max-width: 80%;
                    }
                    .modal > p {
                        width: 90%;
                    }
                    .actions > .cancel-button {
                        width: 120px;
                        margin-right: 10px;
                    }
                    .actions > .delete-button {
                        width: 120px;
                        margin-left: 10px;
                    }
                    .stamps {
                        width: 80%;
                    }
                    .stamp-name {
                        width: 140px;
                        text-overflow: ellipsis;
	                    white-space: nowrap;
                        overflow: hidden;
                        display: block;
                    }
                    .page {
                        display: none;
                    }
                }
            `}</style>
        </UserPage>
    );
};
